import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import roleApi from "../api/roleApi";
// create slice

const name = "role";
const initialState = createInitialState();
const extraActions = createExtraActions();
const extraReducers = createExtraReducers();
const slice = createSlice({ name, initialState, extraReducers });

// exports

export const roleActions = { ...slice.actions, ...extraActions };
export const roleReducer = slice.reducer;

// implementation

function createInitialState() {
  return {
    lstRoles: [],
    lstRolesPaging: [],
    totalCount: 0,
  };
}

function createExtraActions() {
  return {
    getAll: getAll(),
    getRolesPaging: getRolesPaging(),
  };

  function getAll() {
    return createAsyncThunk(
      `${name}/getAll`,
      async () => await roleApi.getAll()
    );
  }
  function getRolesPaging() {
    return createAsyncThunk(
      `${name}/getRolesPaging`,
      async (data) => await roleApi.getRolesPaging(data)
    );
  }
}

function createExtraReducers() {
  return {
    ...getAll(),
    ...getRolesPaging(),
  };

  function getAll() {
    const { pending, fulfilled, rejected } = extraActions.getAll;
    return {
      [pending]: (state) => {
        state.lstRoles = [];
      },
      [fulfilled]: (state, action) => {
        state.lstRoles = action.payload;
      },
      [rejected]: (state, action) => {
        state.lstRoles = [];
      },
    };
  }
  function getRolesPaging() {
    const { pending, fulfilled, rejected } = extraActions.getRolesPaging;
    return {
      [pending]: (state) => {
        state.lstRolesPaging = [];
      },
      [fulfilled]: (state, action) => {
         state.lstRolesPaging = action.payload;
        // state.totalCount = action.payload?.totalResults;
      },
      [rejected]: (state, action) => {
        state.lstRolesPaging = [];
      },
    };
  }
}
